export const COPY_OFFSET_POSITION = 15;
export const COPY_WIDGET_LOCAL_STORAGE_KEY = 'e2CopyWidgetData';
